import { useNavigate } from "react-router-dom";
import { SquareArrowOutUpRight } from "lucide-react";

const FeaturedMatchupCard = ({
  featured,
  roleOrder,
  matchBreakdown,
  tournament,
  matchBreakdownAway,
  matchupDetails,
  getTeamRecord,
  getProjectedWinner,
}) => {
  const navigate = useNavigate();

  if (!featured) return null;

  const FIRE_THRESHOLDS = {
    LPL: 250,
    LEC: 190,
    LCK: 220,
    LCP: 220,
  };

  const openMatch = (matchId) => {
    navigate(`/dashboard/league/${featured.league_id}/history/${matchId}`);
  };

  const SuperscriptNumber = ({ value, color }) => {
    if (value === null || value === undefined || value === "-") {
      return <span>-</span>;
    }

    const [intPart, decimalPart] = Number(value).toFixed(2).split(".");

    return (
      <span style={{ display: "inline-flex", alignItems: "flex-start" }}>
        <span>{intPart}</span>
        <span
          style={{
            fontSize: "16px",
            marginLeft: "6px",
            position: "relative",
            top: "6px",
            opacity: 0.9,
            color,
          }}>
          .{decimalPart}
        </span>
      </span>
    );
  };

  const formatDateUTC = (dateStr) => {
    if (!dateStr) return "Invalid date";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "Invalid date";

    return date.toLocaleDateString(undefined, {
      timeZone: "UTC",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className="featured-matchup-card" style={{ zIndex: "100", paddingBottom: "100px" }}>
      <img
        src="/matchday-live-bg.png"
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          opacity: "0.05",
          objectFit: "cover",
          width: "100%",
          height: "100%",
          minHeight: "220px",
          borderRadius: "12px",
        }}
        alt="Matchday Background"
        id="matchday-live-bg-desktop"
      />
      <img src="/matchday-live-bg.png" alt="Matchday Background" id="matchday-live-bg-mobile" />
      <div
        className="atl-header"
        style={{
          marginBottom: "20px",
          marginTop: " 10px",
          background: " red",
          padding: "10px 0",
          backgroundColor: "#ffffff05",
          border: "1px: solid #19232f",
          borderRadius: "8px",
        }}>
        {featured.week_start && (
          <span style={{ textAlign: " center", fontWeight: " 500" }}>
            Week | {formatDateUTC(featured.week_start)} • {formatDateUTC(featured.week_end)}
          </span>
        )}
      </div>
      <div className="teams-container" style={{ maxWidth: "1200px" }}>
        <div
          style={{
            marginBottom: "20px",
            // background: "#1a232f",
            padding: "10px 40px",
            boxSizing: "border-box",
            borderRadius: "8px",
            position: "relative",
            overflow: "hidden",
            // boxShadow:
            //   "rgba(0, 0, 0, 0.4) 0px -4px 8px -2px inset, rgba(236, 233, 233, 0.2) -1px 3px 6px -2px inset, rgba(0, 0, 0, 0.2) 0px 30px 20px -30px",
            gap: "15px",
          }}
          className="role-row"
          id="matchup-header">
          <div style={{ display: "flex", alignItems: "center", flex: "1", justifyContent: "space-between", zIndex: "100" }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", flexDirection: "column" }}>
              <img src={`/avatars/${featured.home_team?.profile_image}`} alt="Profile" style={{ width: "48px", borderRadius: "4px" }} id="class-4" />
              <div>
                <h3 style={{ color: "white", margin: "0", fontSize: "14px" }}>{featured.home_team?.display_name}</h3>
                <p style={{ color: "white", fontSize: "12px", opacity: "0.6", margin: "0" }}>{getTeamRecord(featured.home_team?.id)}</p>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontWeight: "400", fontSize: "10px", margin: "0", color: "#ffffff99", textAlign: "right" }}>pts</p>
              <h2 className="matchup-versus-total">
                <SuperscriptNumber value={matchupDetails?.home_points} color="white" />
              </h2>
              {/* <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  color: "#ffffff99",
                  fontSize: "13px",
                  fontWeight: "600",
                  justifyContent: "flex-end",
                }}>
                {getProjectedWinner(featured).homeTotal.toFixed(1)}
              </h4> */}
            </div>
          </div>
          {/* Divider with Role */}
          <div className="pts-divider">
            <img src="/vs-vector.png" style={{ opacity: "0.2" }} alt="VS" />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row-reverse",
              flex: "1",
              justifyContent: "space-between",
              zIndex: "100",
            }}>
            <div style={{ display: "flex", alignItems: "flex-end", gap: "10px", flexDirection: "column-reverse" }} className="matchup-">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                <h3 style={{ color: "white", margin: "0", fontSize: "14px" }}>{featured.away_team?.display_name}</h3>
                <p style={{ color: "white", fontSize: "12px", opacity: "0.6", margin: "0" }}>{getTeamRecord(featured.away_team?.id)}</p>
              </div>
              <img src={`/avatars/${featured.away_team?.profile_image}`} alt="Profile" style={{ width: "48px", borderRadius: "4px" }} id="class-4" />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontWeight: "400", fontSize: "10px", margin: "0", color: "#ffffff99" }}>pts</p>
              <h2 className="matchup-versus-total">
                <SuperscriptNumber value={matchupDetails?.away_points} color="white" />
              </h2>
              {/* <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  color: "#ffffff99",
                  fontSize: "13px",
                  fontWeight: "600",
                  justifyContent: "flex-start",
                }}>
                {getProjectedWinner(featured).awayTotal.toFixed(1)}
              </h4> */}
            </div>
          </div>
        </div>

        <div
          style={{
            marginBottom: "20px",
            // background: "#1a232f",
            padding: "10px 40px",
            boxSizing: "border-box",
            borderRadius: "8px",
            // boxShadow:
            //   "rgba(0, 0, 0, 0.4) 0px -4px 8px -2px inset, rgba(236, 233, 233, 0.2) -1px 3px 6px -2px inset, rgba(0, 0, 0, 0.2) 0px 30px 20px -30px",
            gap: "15px",
          }}
          className="role-row"
          id="matchup-header-mobile">
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", flex: "1", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <img
                  src={`/avatars/${featured.home_team?.profile_image}`}
                  alt="Profile"
                  style={{ width: "48px", borderRadius: "4px" }}
                  id="class-4"
                />
                <div>
                  <h3 style={{ color: "white", margin: "0", fontSize: "14px" }}>{featured.home_team?.display_name}</h3>
                  <p style={{ color: "white", fontSize: "12px", opacity: "0.6", margin: "0" }}>{getTeamRecord(featured.home_team?.id)}</p>
                </div>
              </div>
            </div>
            {/* Divider with Role */}
            <div className="pts-divider">
              <img src="/vs-vector.png" style={{ opacity: "0.2" }} alt="VS" />
            </div>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "row-reverse", flex: "1", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }} className="matchup-">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                  <h3 style={{ color: "white", margin: "0", fontSize: "14px" }}>{featured.away_team?.display_name}</h3>
                  <p style={{ color: "white", fontSize: "12px", opacity: "0.6", margin: "0" }}>{getTeamRecord(featured.away_team?.id)}</p>
                </div>
                <img
                  src={`/avatars/${featured.away_team?.profile_image}`}
                  alt="Profile"
                  style={{ width: "48px", borderRadius: "4px" }}
                  id="class-4"
                />
              </div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "center", gap: "50px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontWeight: "400", fontSize: "10px", margin: "0", color: "#ffffff99", textAlign: "right" }}>pts</p>
              <h2 className="matchup-versus-total">
                <SuperscriptNumber value={matchupDetails?.home_points} color="white" />
              </h2>
              <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  color: "#ffffff99",
                  fontSize: "13px",
                  fontWeight: "600",
                  justifyContent: "flex-end",
                }}>
                {getProjectedWinner(featured).homeTotal.toFixed(1)}
              </h4>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontWeight: "400", fontSize: "10px", margin: "0", color: "#ffffff99" }}>pts</p>
              <h2 className="matchup-versus-total">
                <SuperscriptNumber value={matchupDetails?.away_points} color="white" />
              </h2>
              <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  color: "#ffffff99",
                  fontSize: "13px",
                  fontWeight: "600",
                  justifyContent: "flex-start",
                }}>
                {getProjectedWinner(featured).awayTotal.toFixed(1)}
              </h4>
            </div>
          </div>
        </div>

        {roleOrder.map((role, idx) => {
          const homePlayer = featured.home_team?.user_fantasy_team_players?.find((p) => p.players.role.toLowerCase() === role.toLowerCase());
          const awayPlayer = featured.away_team?.user_fantasy_team_players?.find((p) => p.players.role.toLowerCase() === role.toLowerCase());
          const homePlayerImage = homePlayer?.equipped_skin?.full_preview ?? homePlayer?.players?.player_image;
          const awayPlayerImage = awayPlayer?.equipped_skin?.full_preview ?? awayPlayer?.players?.player_image;

          // const isOnFireHome = FIRE_THRESHOLDS[tournament.region] && homePlayer.week_points >= FIRE_THRESHOLDS[tournament.region];
          // const isOnFireAway = FIRE_THRESHOLDS[tournament.region] && awayPlayer.week_points >= FIRE_THRESHOLDS[tournament.region];
          return (
            <div key={role} className="role-row">
              {/* Home Player */}
              {homePlayer ? (
                <div
                  className="player-card"
                  style={{
                    alignItems: "stretch",
                    flexDirection: "row",
                    position: " relative",
                    overflow: "hidden",
                    // boxShadow:
                    //   " rgba(0, 0, 0, 0.4) 0px -4px 8px -2px inset, rgba(236, 233, 233, 0.2) -1px 3px 6px -2px inset,  rgba(0, 0, 0, 0.2) 0px 30px 20px -30px",
                    background: `linear-gradient(
  130deg,
  rgba(${homePlayer.players.teams.color}, 0.3),
rgb(7 13 23) 70%
)`,
                  }}>
                  <img
                    src={`/players/${homePlayerImage}`}
                    alt={homePlayer.players.name}
                    style={{ width: "94px", height: "fit-content", zIndex: "100", marginLeft: "10px" }}
                    className="player-image"
                  />
                  <img
                    src={`/teams/${homePlayer.players.teams.team_logo}`}
                    alt={homePlayer.players.teams.name}
                    style={{
                      position: "absolute",
                      height: "160px",
                      width: "160px",
                      objectFit: "contain",
                      opacity: "0.1",
                      left: "-40px",
                      top: "-20px",
                      zIndex: "1",
                    }}
                    className="team-bg-logo"
                  />
                  <div style={{ display: "flex", flexDirection: "column", width: "100%", zIndex: "100" }}>
                    <div className="matchup-player-info-home">
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className="matchup-player-info-boosts">
                        <p
                          style={{
                            color: "white",
                            fontWeight: "700",
                            margin: 0,
                            fontSize: "16px",
                            letterSpacing: "-0.4px",
                            textTransform: "uppercase",
                            textAlign: "start",
                          }}
                          className="player-name-navigate"
                          onClick={() => navigate(`/dashboard/league/${featured.league_id}/player/${homePlayer.player_id}`)}>
                          {homePlayer.players.name}
                        </p>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div
                            className="level-hexagon"
                            style={{
                              marginBottom: "0",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "800",
                              fontSize: "12px",
                              textShadow: "0px 0px 8px rgba(0, 0, 0, 1)",
                            }}>
                            {homePlayer.player_training_progress?.find((t) => t.region_league_id === featured.league_id)?.training_level ?? "0"}
                          </div>
                          {homePlayer.boosts && (
                            <img
                              src={`/boosts/${homePlayer.boosts.item_image}`}
                              alt={homePlayer.boosts.name}
                              className="boost-icon"
                              style={{ width: "18px", height: "18px" }}
                            />
                          )}
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          {FIRE_THRESHOLDS[tournament.region] && homePlayer.week_points >= FIRE_THRESHOLDS[tournament.region] && (
                            <img src="/Fire_blue.gif" style={{ objectFit: "contain", height: "24px", width: "24px", marginTop: "-4px" }} alt="Fire" />
                          )}
                          <p className="matchup-player-info-away-points">{homePlayer.week_points.toFixed(2)}</p>
                        </div>
                        <p className="h2h-projection">{homePlayer.h2h_projected}</p>
                      </div>
                    </div>
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <img
                        src={`/teams/${homePlayer.players.teams.team_logo}`}
                        alt={homePlayer.players.teams.name}
                        style={{ width: "16px", height: "16px", borderRadius: "0", objectFit: "contain" }}
                      />
                      <p style={{ color: "#aaa", margin: 0, fontSize: "10px" }}>|</p>
                      <p style={{ color: "white", opacity: "0.4", margin: 0, fontSize: "10px" }}>{homePlayer.players.role}</p>
                    </span>
                    {homePlayer &&
                      (() => {
                        const breakdowns = matchBreakdown.filter((m) => m.player_id === homePlayer.player_id);

                        return breakdowns.length > 0 ? (
                          breakdowns.map((breakdown) => (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
                              <div key={breakdown.match_id} className="match-breakdown-container">
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <p style={{ color: "white", opacity: "0.4" }}>vs</p>
                                    <img
                                      src={`/teams/${breakdown.opponent_team_logo}`}
                                      alt={breakdown.opponent_team_name}
                                      style={{ width: "13px", height: "13px", objectFit: "contain", borderRadius: "0" }}
                                    />
                                  </div>
                                  <p style={{ color: "white", fontWeight: "700", fontSize: "13px" }}>{breakdown.boosted_points?.toFixed(1)}</p>
                                </div>
                                <div style={{ display: "flex", gap: "6px" }}>
                                  <p style={{ color: "white", opacity: "0.4" }}>KDA</p>
                                  <p style={{ color: "white", opacity: "0.8", fontWeight: "600" }}>
                                    {breakdown.total_kills}/{breakdown.total_deaths}/{breakdown.total_assists}
                                  </p>
                                </div>
                              </div>
                              <span onClick={() => openMatch(breakdown.match_id)} style={{ cursor: "pointer" }}>
                                <SquareArrowOutUpRight size={18} color="rgb(190, 205, 227)" />
                              </span>
                            </div>
                          ))
                        ) : (
                          <p style={{ fontSize: "14px", color: "white", opacity: "0.4" }}>No games played</p>
                        );
                      })()}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    minWidth: "220px",
                    color: "white",
                    opacity: "0.6",
                    flex: "1 1",
                    boxShadow:
                      " rgba(0, 0, 0, 0.4) 0px -4px 8px -2px inset, rgba(236, 233, 233, 0.2) -1px 3px 6px -2px inset,  rgba(0, 0, 0, 0.2) 0px 30px 20px -30px",
                    background: `linear-gradient(
  230deg,
  rgb(7 13 23),
rgb(7 13 23) 70%
)`,
                    borderRadius: "8px",
                  }}>
                  No player
                </div>
              )}

              {/* Divider with Role */}
              <div className="vs-divider">
                <img src={`/roles/${role}.svg`} alt={role} style={{ width: "21px", height: "21px", objectFit: "contain" }} />
              </div>
              {/* Away Player */}
              {awayPlayer ? (
                <div
                  className="player-card"
                  style={{
                    alignItems: "stretch",
                    flexDirection: "row-reverse",
                    position: "relative",
                    overflow: "hidden",
                    // boxShadow:
                    //   " rgba(0, 0, 0, 0.4) 0px -4px 8px -2px inset, rgba(236, 233, 233, 0.2) -1px 3px 6px -2px inset,  rgba(0, 0, 0, 0.2) 0px 30px 20px -30px",
                    background: `linear-gradient(
  230deg,
  rgba(${awayPlayer.players.teams.color}, 0.3),
rgb(7 13 23) 70%
)`,
                  }}>
                  <img
                    src={`/players/${awayPlayerImage}`}
                    alt={awayPlayer.players.name}
                    style={{ width: "94px", height: "fit-content", zIndex: "100", marginRight: "10px" }}
                    className="player-image"
                  />
                  <img
                    src={`/teams/${awayPlayer.players.teams.team_logo}`}
                    alt={awayPlayer.players.teams.name}
                    style={{
                      position: "absolute",
                      height: "160px",
                      width: "160px",
                      objectFit: "contain",
                      opacity: "0.1",
                      right: "-40px",
                      top: "-20px",
                      zIndex: "1",
                    }}
                    className="team-bg-logo"
                  />
                  <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "flex-end", gap: "0px", zIndex: "100" }}>
                    <div className="matchup-player-info-away">
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <p className="matchup-player-info-away-points">{awayPlayer.week_points.toFixed(2)}</p>
                          {FIRE_THRESHOLDS[tournament.region] && awayPlayer.week_points >= FIRE_THRESHOLDS[tournament.region] && (
                            <img src="/Fire_blue.gif" style={{ objectFit: "contain", height: "24px", width: "24px", marginTop: "-4px" }} alt="Fire" />
                          )}
                        </div>
                        <p className="h2h-projection">{awayPlayer.h2h_projected}</p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className="matchup-player-info-boosts-away">
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          {awayPlayer.boosts && (
                            <img
                              src={`/boosts/${awayPlayer.boosts.item_image}`}
                              alt={awayPlayer.boosts.name}
                              className="boost-icon"
                              style={{ width: "18px", height: "18px" }}
                            />
                          )}
                          <div
                            className="level-hexagon"
                            style={{
                              marginBottom: "0",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "800",
                              fontSize: "12px",
                              textShadow: "0px 0px 8px rgba(0, 0, 0, 1)",
                            }}>
                            {awayPlayer.player_training_progress?.find((t) => t.region_league_id === featured.league_id)?.training_level ?? "0"}
                          </div>
                        </div>
                        <p
                          style={{
                            color: "white",
                            fontWeight: "700",
                            margin: 0,
                            fontSize: "16px",
                            letterSpacing: "-0.4px",
                            textTransform: "uppercase",
                            textAlign: "end",
                          }}
                          className="player-name-navigate"
                          onClick={() => navigate(`/dashboard/league/${featured.league_id}/player/${awayPlayer.player_id}`)}>
                          {awayPlayer.players.name}
                        </p>
                      </div>
                    </div>
                    <span style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                      <p style={{ color: "white", opacity: "0.4", margin: 0, fontSize: "10px" }}>{awayPlayer.players.role}</p>
                      <p style={{ color: "#aaa", margin: 0, fontSize: "10px" }}>|</p>
                      <img
                        src={`/teams/${awayPlayer.players.teams.team_logo}`}
                        alt={awayPlayer.players.teams.name}
                        style={{ width: "16px", height: "16px", borderRadius: "0", objectFit: "contain" }}
                      />
                    </span>
                    {awayPlayer &&
                      (() => {
                        const breakdowns = matchBreakdownAway.filter((m) => m.player_id === awayPlayer.player_id);

                        return breakdowns.length > 0 ? (
                          breakdowns.map((breakdown) => (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", width: "100%" }}>
                              <span onClick={() => openMatch(breakdown.match_id)} style={{ cursor: "pointer" }}>
                                <SquareArrowOutUpRight size={18} color="rgb(190, 205, 227)" />
                              </span>
                              <div key={breakdown.match_id} className="match-breakdown-container">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row-reverse",
                                    justifyContent: "space-between",
                                  }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                      flexDirection: "row-reverse",
                                    }}>
                                    <p style={{ color: "white", opacity: "0.4" }}>vs</p>
                                    <img
                                      src={`/teams/${breakdown.opponent_team_logo}`}
                                      alt={breakdown.opponent_team_name}
                                      style={{ width: "13px", height: "13px", objectFit: "contain", borderRadius: "0" }}
                                    />
                                  </div>

                                  <p style={{ color: "white", fontWeight: "700", fontSize: "13px" }}>{breakdown.boosted_points?.toFixed(1)}</p>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    gap: "6px",
                                    justifyContent: "flex-start",
                                    flexDirection: "row-reverse",
                                  }}>
                                  <p style={{ color: "white", opacity: "0.4" }}>KDA</p>
                                  <p style={{ color: "white", opacity: "0.8", fontWeight: "600" }}>
                                    {breakdown.total_kills}/{breakdown.total_deaths}/{breakdown.total_assists}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p style={{ fontSize: "14px", color: "white", opacity: "0.4" }}>No games played</p>
                        );
                      })()}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    minWidth: "220px",
                    color: "white",
                    opacity: "0.6",
                    flex: "1 1",
                    boxShadow:
                      " rgba(0, 0, 0, 0.4) 0px -4px 8px -2px inset, rgba(236, 233, 233, 0.2) -1px 3px 6px -2px inset,  rgba(0, 0, 0, 0.2) 0px 30px 20px -30px",
                    background: `linear-gradient(
  230deg,
  rgb(7 13 23),
rgb(7 13 23) 70%
)`,
                    borderRadius: "8px",
                  }}>
                  No player
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default FeaturedMatchupCard;
